import React, { Component, Fragment } from 'react';
import Image from 'next/image';
import { message, Pagination, List, Row, Col } from 'antd';
import articleList from '../../api/articleApi';
import { timerFormat } from '../../utils/utils';

import defaultImg from '../../public/images/hidream-admin-bg.jpg';

export class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 6,
      total: '',
      articleListData: [],
    };
  }

  componentDidMount() {
    this.getArticleList();
  }

  getArticleList = () => {
    const data = {
      page: this.state.page,
      limit: this.state.limit,
    };

    articleList(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          articleListData: res.data.data.data,
          total: res.data.data.total,
        });
      } else {
        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs);
      }
    });
  };

  onChangeCurrnePage = (page, pageSize) => {
    if (page < 1) {
      page = this.state.page;
    }
    const data = {
      page: page,
      limit: pageSize,
    };

    articleList(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          articleListData: res.data.data.data,
          total: res.data.data.total,
        });

        window.scrollTo(0, 0);
      }
    });
  };

  render() {
    const { articleListData, total } = this.state;

    return (
      <Fragment>
        <List
          itemLayout="vertical"
          pagination={false}
          dataSource={articleListData}
          renderItem={(item) => (
            <List.Item key={item.title} className="listItem">
              <Row>
                <Col md={8} lg={8} xl={8} className="listLeft">
                  <a
                    className="listImage"
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Image
                      src={item.src ? `${item.src}` : defaultImg}
                      alt={item.title}
                      width={492}
                      height={276}
                      layout="responsive"
                    />
                  </a>
                </Col>

                <Col md={16} lg={16} xl={16} className="listRight">
                  <div className="header">
                    <a href={item.link} target="_blank" rel="noreferrer">
                      <div className="title">{item.title}</div>
                      <p className="description">
                        {item.description ? item.description : ''}
                      </p>
                    </a>
                  </div>

                  <Row>
                    <Col span={12} className="origin">
                      讯梦国际
                    </Col>
                    <Col span={12} className="time">
                      {item.updated_at
                        ? timerFormat(item.updated_at)
                        : item.updated_at}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </List.Item>
          )}
        />

        <Row justify="center">
          <Col>
            <Pagination
              total={total}
              onChange={this.onChangeCurrnePage}
              pageSize={this.state.limit}
              hideOnSinglePage
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default ArticleList;
